import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-11cae904"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    id: "login",
    class: "container"
};
const _hoisted_2 = { class: "logo-box" };
const _hoisted_3 = { class: "login-container" };
const _hoisted_4 = { class: "back-box" };
const _hoisted_5 = /*#__PURE__*/ _createTextVNode(" 返回 ");
const _hoisted_6 = { class: "title" };
import { switchLogin } from "@/service/login";
import { appCounterStore } from "@/store/app";
import { useCounterStore } from "@/store/user";
import { getQueryParam } from "@/utils";
import { computed, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import AccountList from "./components/AccountList.vue";
import BindMFA from "./components/BindMFA.vue";
import Foot from "./components/Foot.vue";
import { useLogin } from "./components/hooks";
import LoginForm from "./components/LoginForm.vue";
import MFAForm from "./components/MFA.vue";
import ResetPassword from "./components/ResetPassword.vue";
import Signup from "./components/Signup.vue";
import SignupNotify from "./components/SignupNotify.vue";
export default /*#__PURE__*/ _defineComponent({
    name: 'login',
    setup(__props) {
        const redirect_url = getQueryParam("redirect_url");
        const { changeState, goLogin } = useLogin();
        const route = useRoute();
        const router = useRouter();
        const store = appCounterStore();
        const userStore = useCounterStore();
        const loginState = computed(() => store.getLoginState);
        const hasback = ["MFA", "bindMFA", "reset", "accountList"];
        const backShow = computed(() => hasback.indexOf(store.getLoginState) !== -1);
        const getQuery = (value) => {
            let arr = value?.split("&") || [];
            let obj = {};
            for (let item of arr) {
                let piece = item.split("=");
                obj[piece[0]] = piece[1];
            }
            return obj;
        };
        const { redirect } = route.query;
        let pathArr = Array.isArray(redirect)
            ? redirect[0]
            : (redirect || "").split("?");
        const path = (pathArr && pathArr[0]) || "/";
        const query = pathArr ? getQuery(pathArr[1]) : {};
        let accountInfo = {
            accountList: [],
            accountPhone: "",
            temp_token: ""
        };
        const accountPhone = ref("");
        const accountList = ref([]);
        watch(() => userStore.getAccountInfo, (newV) => {
            accountInfo = newV;
            accountList.value = accountInfo.accountList || [];
            accountPhone.value = accountInfo.accountPhone || "";
        }, { immediate: true });
        const loginHandle = (data) => {
            accountConfirm(data);
        };
        const clickHandle = (data) => {
            let params = {
                user_id: data.user_id,
                temp_token: accountInfo.temp_token
            };
            switchLogin(params).then((res) => {
                userStore.storeRemoveAccountInfo();
                accountConfirm(res);
            });
        };
        const accountConfirm = (res) => {
            userStore.setValue(res.data);
            if (!res.data.need_reset_password) {
                jumpHandle();
            }
            else {
                changeState("reset");
            }
        };
        const jumpHandle = () => {
            changeState("already");
            if (!redirect_url) {
                router.push({ path: path, query: query });
            }
            else {
                window.location.href = redirect_url;
            }
        };
        return (_ctx, _cache) => {
            const _component_svg_icon = _resolveComponent("svg-icon");
            const _component_el_card = _resolveComponent("el-card");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_svg_icon, {
                        "icon-class": "logo1",
                        class: "logo-icon-style"
                    })
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_el_card, { class: "box-card" }, {
                        default: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", _hoisted_4, [
                                _createElementVNode("span", {
                                    class: "back",
                                    onClick: _cache[0] || (_cache[0] =
                                        //@ts-ignore
                                        (...args) => (_unref(goLogin) && _unref(goLogin)(...args)))
                                }, [
                                    _createVNode(_component_svg_icon, {
                                        "icon-class": "left",
                                        "class-name": "left-icon"
                                    }),
                                    _hoisted_5
                                ])
                            ], 512), [
                                [_vShow, _unref(backShow)]
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_6, " 欢迎来到英博云 ", 512), [
                                [_vShow, _unref(loginState) !== 'accountList']
                            ]),
                            (_unref(loginState) === 'login')
                                ? (_openBlock(), _createBlock(LoginForm, {
                                    key: 0,
                                    onLoginHandle: loginHandle
                                }))
                                : (_unref(loginState) === 'accountList')
                                    ? (_openBlock(), _createBlock(AccountList, {
                                        key: 1,
                                        account: accountList.value,
                                        phone: accountPhone.value,
                                        onClickHandle: clickHandle
                                    }, null, 8, ["account", "phone"]))
                                    : (_unref(loginState) === 'signup')
                                        ? (_openBlock(), _createBlock(Signup, { key: 2 }))
                                        : (_unref(loginState) === 'MFA')
                                            ? (_openBlock(), _createBlock(MFAForm, { key: 3 }))
                                            : (_unref(loginState) === 'reset')
                                                ? (_openBlock(), _createBlock(ResetPassword, {
                                                    key: 4,
                                                    onSuccess: jumpHandle
                                                }))
                                                : (_unref(loginState) === 'bindMFA')
                                                    ? (_openBlock(), _createBlock(BindMFA, { key: 5 }))
                                                    : (_unref(loginState) === 'notify')
                                                        ? (_openBlock(), _createBlock(SignupNotify, { key: 6 }))
                                                        : _createCommentVNode("", true)
                        ]),
                        _: 1
                    })
                ]),
                _createVNode(Foot)
            ]));
        };
    }
});
